/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { ScenarioFull } from "../../../../models/http/what-if/scenario/scenario-full.model";

export const CREATE_NEW_SCENARIO_RESPONSE = {
	id: 80885
};

export const GET_SCENARIO_INFO_RESPONSE: Record<number, ScenarioFull> = {
	1337: {
		name: "Baseline",
		simulationStartDate: "2023-01-18T12:00:00",
		isBaseline: true,
		status: "CREATED",
		layers: [
			{
				name: "MYSQL_01",
				region: "FR",
				pue: 1.67562,
				cloudProvider: "aws",
				cpuLoad: {
					morning: 20,
					afternoon: 20,
					evening: 25,
					night: 35
				},
				gpuLoad: {
					morning: 20,
					afternoon: 20,
					evening: 25,
					night: 35
				}
			}
		],
		barChart: {
			title: "Layers forecast for Baseline scenario",
			barSeries: [
				{
					name: "CO2e Emissions",
					bars: [
						{
							name: "Compute Engine Machine Learning",
							value: 490.419,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 490.419
						},
						{
							name: "GKE Cluster",
							value: 402.945,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 402.945
						},
						{
							name: "Cloud Function",
							value: 67.429,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 67.429
						},
						{
							name: "Cloud Sql Postgres",
							value: 373.432,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 373.432
						}
					]
				}
			]
		}
	},
	1335: {
		name: "Scenario 01",
		simulationStartDate: "2023-01-18T12:00:00",
		isBaseline: true,
		status: "CREATED",
		layers: [
			{
				name: "MYSQL_01",
				region: "FR",
				pue: 1.67562,
				cloudProvider: "aws",
				cpuLoad: {
					morning: 20,
					afternoon: 20,
					evening: 25,
					night: 35
				},
				gpuLoad: {
					morning: 20,
					afternoon: 20,
					evening: 25,
					night: 35
				}
			},
			{
				name: "WebLogic",
				region: "FR",
				pue: 1.67254,
				cloudProvider: "aws",
				cpuLoad: {
					morning: 20,
					afternoon: 20,
					evening: 25,
					night: 35
				},
				gpuLoad: {
					morning: 20,
					afternoon: 20,
					evening: 25,
					night: 35
				}
			}
		],
		barChart: {
			title: "Layers forecast for Baseline scenario",
			barSeries: [
				{
					name: "CO2e Emissions",
					bars: [
						{
							name: "Compute Engine Machine Learning",
							value: 490.419,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 490.419
						},
						{
							name: "GKE Cluster",
							value: 402.945,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 402.945
						},
						{
							name: "Cloud Function",
							value: 67.429,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 67.429
						},
						{
							name: "Cloud Sql Postgres",
							value: 373.432,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 373.432
						}
					]
				}
			]
		}
	},
	80885: {
		name: "Scenario 02",
		simulationStartDate: "2023-01-18T12:00:00",
		isBaseline: true,
		status: "CREATED",
		layers: [
			{
				name: "WebLogic",
				region: "FR",
				pue: 1.67254,
				cloudProvider: "aws",
				cpuLoad: {
					morning: 20,
					afternoon: 20,
					evening: 25,
					night: 35
				},
				gpuLoad: {
					morning: 20,
					afternoon: 20,
					evening: 25,
					night: 35
				}
			}
		],
		barChart: {
			title: "Layers forecast for Baseline scenario",
			barSeries: [
				{
					name: "CO2e Emissions",
					bars: [
						{
							name: "Compute Engine Machine Learning",
							value: 490.419,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 490.419
						},
						{
							name: "GKE Cluster",
							value: 402.945,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 402.945
						},
						{
							name: "Cloud Function",
							value: 67.429,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 67.429
						},
						{
							name: "Cloud Sql Postgres",
							value: 373.432,
							unit: "kgCO2e",
							tenantRegion: true,
							baselineValue: 373.432
						}
					]
				}
			]
		}
	}
};

export const DELETE_SCENARIO_RESPONSE = {
	message: "Deleted with success"
};

export const GET_SCENARIO_SIMULATION_STATUS_RESPONSE = {
	status: "DONE"
};
